<!--
 * @Description: file content
 * @Author: yangsibo
 * @Date: 2022-06-06 09:39:33
 * @LastEditors: yangsibo
 * @LastEditTime: 2022-06-06 18:01:23
 * @FilePath: \YunYin_admin\src\views\Cooperative\SetQuery\Account.vue
-->
<template>
  <AccountList></AccountList>
</template>

<script>
import AccountList from "@/components/Query/AccountList";
export default {
  name: "Account",
  data() {
    return {};
  },
  components: { AccountList },
  filters: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
</style>
